import { TaskChecklist } from 'aos-services/src/dataaccess/tasks/types/TaskDto'
import { Box } from 'aos-ui/src/components/base/Box'
import { Text } from 'aos-ui/src/components/base/Text'
import { ThemeVariant } from 'aos-ui/src/components/base/ThemeVariant'
import { Icon } from 'aos-ui/src/components/svg/Icon'
import { SvgIcon } from 'aos-ui/src/components/svg/SvgIcon'
import { Color } from 'aos-ui-common/src/styles/Color'
import { Link } from 'aos-ui-universal'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const TaskTemplateChecklists = ({
    checklists = [],
    variant = ThemeVariant.White,
}: {
    checklists: TaskChecklist[]
    variant?: ThemeVariant
}) => {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState<number[]>([])

    const textColor = variant === ThemeVariant.White ? Color.TextPrimary : Color.TextDarkPrimary
    const textSecondaryColor =
        variant === ThemeVariant.White ? Color.TextSecondary : Color.TextDarkSecondary

    useEffect(() => {
        queueMicrotask(() => {
            setExpanded(checklists.map(({ id }) => id))
        })
    }, [checklists])

    const toggleExpanded = useCallback(
        (id: number) =>
            setExpanded(state =>
                state.includes(id) ? state.filter(item => item !== id) : [...state, id],
            ),
        [],
    )
    return (
        <Box>
            <Box row columnGap={8} alignItems='center'>
                <Icon iconSize={24} svg={SvgIcon.Checklist} color={textColor} />
                <Text weight='light' size={18} color={textColor} verticalAlign='middle'>
                    {t('checklist-manager.templates.item-section-title', { ns: 'checklist' })}
                </Text>
            </Box>
            <Box column rowGap={16} paddingVertical={16}>
                {checklists.map(checklist => {
                    const isOpen = expanded.includes(checklist.id)
                    return (
                        <Box column rowGap={8} key={checklist.id}>
                            <Box column rowGap={4}>
                                <Text color={textColor} size={13}>
                                    {checklist.name}
                                </Text>
                                {checklist.items.length > 0 && (
                                    <Box column rowGap={4}>
                                        <Link
                                            size='caption'
                                            onPress={() => toggleExpanded(checklist.id)}
                                        >
                                            {isOpen
                                                ? t('status-dashboard.show-less', {
                                                      ns: 'dashboard',
                                                  })
                                                : t('status-dashboard.show-more', {
                                                      ns: 'dashboard',
                                                  })}
                                        </Link>
                                        {isOpen && (
                                            <Box column rowGap={8}>
                                                {checklist.items.map(item => (
                                                    <Box
                                                        key={item.id}
                                                        row
                                                        columnGap={8}
                                                        alignItems='center'
                                                    >
                                                        <Icon
                                                            iconSize={16}
                                                            svg={SvgIcon.ChecklistItem}
                                                            color={textSecondaryColor}
                                                        />
                                                        <Text size={13} color={textSecondaryColor}>
                                                            {item.content}
                                                        </Text>
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}
